import { useState } from "react";
import { EmailEntry } from "./emailEntry";
import { PasswordEntry } from "./passwordEntry";
import { CreateAccount } from "./createAccount";
import { toast } from "react-hot-toast";

type AuthStep = "email" | "password" | "account-selection" | "create-account";

interface Account {
  email: string;
  name: string;
}

export const AuthFlow = () => {
  const [currentStep, setCurrentStep] = useState<AuthStep>("email");
  const [email, setEmail] = useState("");

  const handleEmailSubmit = (email: string, existingAccount: boolean) => {
    if (existingAccount) {
      setEmail(email);
      setCurrentStep("password");
    } else {
      toast.error("Email not found");
    }
  };

  const handlePasswordSubmit = (password: string) => {
    // Here you would typically handle authentication with your backend
    toast.success("Login successful");
  };

  const handleAccountSelect = (account: Account) => {
    setEmail(account.email);
    setCurrentStep("password");
  };

  const handleCreateAccount = () => {
    toast.success("Account created successfully");
    // setCurrentStep("email");
  };

  return (
    <div className="relative min-h-screen">
      {currentStep === "email" && (
        <EmailEntry
          onSubmit={handleEmailSubmit}
          onCreateAccount={() => setCurrentStep("create-account")}
        />
      )}

      {currentStep === "password" && (
        <PasswordEntry
          email={email}
          onSubmit={handlePasswordSubmit}
          onBack={() => setCurrentStep("email")}
          onForgotPassword={() => console.log("Forgot password")}
        />
      )}

      {/* {currentStep === "account-selection" && (
        <AccountSelection
          accounts={[]}
          onAccountSelect={handleAccountSelect}
          onUseAnotherAccount={() => setCurrentStep("email")}
          selectedEmail={email}
        />
      )} */}

      {currentStep === "create-account" && (
        <CreateAccount
          onSubmit={handleCreateAccount}
          onBack={() => setCurrentStep("email")}
        />
      )}
    </div>
  );
};
